import { ProductCategoriesById } from "../modules";

export const ProductCategoriesByIdPage = () => {
  return <ProductCategoriesById />;
};
